import mutationFactory from '../../lib/mutationFactory';

import Vue from 'vue';

export default {
  ...mutationFactory({
    singular: 'dashboard',
    plural: 'dashboards'
  }),
  ...mutationFactory(
    {
      singular: 'dashboard',
      plural: 'dashboards'
    },
    {
      singular: 'widget',
      plural: 'widgets'
    }
  ),
  SET_SELECTED_DASHBOARD: (state, dashboard) => {
    state.selectedDashboard = dashboard || {};
  },
  UPDATE_WIDGETS: (state, { widgets }) => {
    Vue.set(state.selectedDashboard, 'widgets', widgets);
  },
  UPDATE_DATE_RANGE: (state, { startDate, endDate, period }) => {
    Vue.set(state.selectedDashboard, 'startDate', startDate);
    Vue.set(state.selectedDashboard, 'endDate', endDate);
    Vue.set(state.selectedDashboard, 'period', period);
  },

  GET_ACCOUNT_TYPES_REQUEST: state => {
    state.loadingAction.getAccountTypes = true;
    state.errorAction.getAccountTypes = false;
  },
  GET_ACCOUNT_TYPES_SUCCESS: (state, { body, widgetId }) => {
    state.loadingAction.getAccountTypes = false;
    state.errorAction.getAccountTypes = false;

    Vue.set(state.accountTypes, widgetId, body);
  },

  GET_ACCOUNT_TYPES_ERROR: state => {
    state.loadingAction.getAccountTypes = false;
    state.errorAction.getAccountTypes = true;
  },

  REMOVE_WIDGET_SUCCESS: (state, body) => {
    state.selectedDashboard.widgets = state.selectedDashboard.widgets.filter(w => w._id !== body._id);
  },

  CREATE_WIDGET_SUCCESS: (state, body) => {
    state.selectedDashboard.widgets.push(body);
  },

  UPDATE_WIDGET_SUCCESS: (state, body) => {
    const widgetIndex = state.selectedDashboard.widgets.findIndex(w => w._id === body._id);
    if (widgetIndex !== -1) {
      Vue.set(state.selectedDashboard.widgets, widgetIndex, body);
    }
  },

  REFRESH_WIDGET_REQUEST: (state, { id }) => {
    Vue.set(state.loadingAction.getWidgetData, id, true);
    Vue.set(state.errorAction.getWidgetData, id, false);
  },
  REFRESH_WIDGET_SUCCESS: (state, { id, body }) => {
    Vue.set(state.loadingAction.getWidgetData, id, false);
    Vue.set(state.errorAction.getWidgetData, id, false);
    Vue.set(state.data, id, body);
  },
  REFRESH_WIDGET_ERROR: (state, { id, error }) => {
    Vue.set(state.loadingAction.getWidgetData, id, false);
    Vue.set(state.errorAction.getWidgetData, id, error);
  },

  GET_ANALYTICS_REQUEST: (state, { id, request }) => {
    if (state.requests[id]) state.requests[id].abort();

    Vue.set(state.loadingAction.getAnalytics, id, true);
    Vue.set(state.errorAction.getAnalytics, id, false);
    Vue.set(state.requests, id, request);

    Vue.set(state.analytics, id, {});
  },
  GET_ANALYTICS_SUCCESS: (state, { id, body }) => {
    Vue.set(state.loadingAction.getAnalytics, id, false);
    Vue.set(state.errorAction.getAnalytics, id, false);
    Vue.set(state.requests, id, false);

    Vue.set(state.analytics, id, body);
  },
  GET_ANALYTICS_ERROR: (state, { id, error }) => {
    Vue.set(state.loadingAction.getAnalytics, id, false);
    Vue.set(state.errorAction.getAnalytics, id, error);
    Vue.set(state.requests, id, false);
  },

  SET_EDIT_MODE: (state, id) => {
    state.editMode = id;
  },
  SET_DRAGGING: (state, id) => {
    state.dragging = id;
  },
  SET_DROP_TARGET: (state, id) => {
    state.dropTarget = id;
  }
};
